import { AxiosResponse } from 'axios';
import internalApiClient from '~/app/shared/util/api/internalApiClient';
import { BookedEntryDepartment } from '~/types/internal-api';
import { getAPIErrorValidation } from '~/utilities/parseAPIValidationErrors';

export function updateBookedEntryDimensionValues(data: BookedEntryDepartment[]): Promise<AxiosResponse> {
    try {
        return internalApiClient.post<undefined, AxiosResponse, BookedEntryDepartment[]>(
            `internal-api/booked-entry/update-department`,
            data
        );
    } catch (error) {
        error.validation = getAPIErrorValidation(error);
        return Promise.reject(error);
    }
}

export const dimensionsApiErrorTextIds = [
    'ERROR_CODE_ONLYONEITEMPERDIMENSION',
    'ERROR_CODE_ONLYONEDISTRIBUTIONALLOWED',
    'ERROR_CODE_CONTAINSINVALIDVALUES',
    'ERROR_CODE_BOOKEDENTRYMULTIPLEDIMENSIONREQUIRED',
];
